// extracted by mini-css-extract-plugin
module.exports = {"list":"_d02980c","button":"_2d3ce3c"};